import React from "react";
import { Button, Tooltip } from "antd";

import "./styles.scss";

const PrimaryButton = (props) => {
  const {
    htmlType,
    onClick,
    type,
    title,
    disabled,
    className,
    tooltip,
    key,
    id,
    testid,
    loading = false,
  } = props;

  return (
    <>
      {tooltip ? (
        <Tooltip placement="bottomRight" title={tooltip}>
          <Button
            htmlType={htmlType}
            className={className}
            onClick={onClick}
            type={type}
            disabled={disabled}
            id={id}
            data-testid={testid}
            loading={loading}
          >
            {title}
          </Button>
        </Tooltip>
      ) : (
        <Button
          key={key}
          htmlType={htmlType}
          className={className}
          onClick={onClick}
          type={type}
          disabled={disabled}
          id={id}
          data-testid={testid}
          loading={loading}
        >
          {title}
        </Button>
      )}
    </>
  );
};

const ClearButton = (props) => {
  const { title, onClick, className, id, ...rest } = props;

  return (
    <Button
      {...rest}
      onClick={onClick}
      className={`custom-clear-button ${className}`}
      id={id}
    >
      {title}
    </Button>
  );
};

const CustomButton = (props) => {
  const { btntype } = props;

  if (btntype === "clear") {
    return <ClearButton {...props} />;
  } else {
    return <PrimaryButton {...props} />;
  }
};

export default CustomButton;
